import { GlobalState } from "src/reducers";

export const getStoredPreApprovalCode = (state: GlobalState): string | null =>
    state.ui.auth.preApprovalCode;
